import { Icon } from '@iconify/react';
import { cn } from '../../lib/utils';
import {
  PASSWORD_RULES,
  evaluatePassword,
  passwordStrengthColor,
  passwordStrengthLabel,
} from '../../lib/passwordStrength';

type Props = {
  password: string;
  className?: string;
};

export function PasswordStrengthMeter({ password, className }: Props) {
  const { score, passed } = evaluatePassword(password);
  const total = PASSWORD_RULES.length;
  const barColor = passwordStrengthColor(score);
  const label = password.length === 0 ? '—' : passwordStrengthLabel(score);

  return (
    <div className={cn('space-y-2', className)}>
      <div className="flex items-center gap-2">
        <div className="flex-1 h-1.5 bg-muted rounded-full overflow-hidden">
          <div
            className={cn('h-full transition-all duration-200', barColor)}
            style={{ width: `${(score / total) * 100}%` }}
          />
        </div>
        <span className="text-[11px] font-medium text-muted-foreground w-16 text-right">
          {label}
        </span>
      </div>

      <ul className="grid grid-cols-1 sm:grid-cols-2 gap-x-3 gap-y-1">
        {PASSWORD_RULES.map((rule) => {
          const ok = passed[rule.id];
          return (
            <li
              key={rule.id}
              className={cn(
                'flex items-center gap-1.5 text-[11px]',
                ok ? 'text-emerald-600' : 'text-muted-foreground',
              )}
            >
              <Icon
                icon={ok ? 'lucide:check-circle-2' : 'lucide:circle'}
                className="w-3 h-3 shrink-0"
              />
              <span>{rule.label}</span>
            </li>
          );
        })}
      </ul>
    </div>
  );
}
